// extracted by mini-css-extract-plugin
export var bottom = "Footer-module--bottom--50b2f";
export var contact = "Footer-module--contact--1401f";
export var itemWithSvg = "Footer-module--itemWithSvg--5ee35";
export var links = "Footer-module--links--dcd29";
export var linksItem = "Footer-module--linksItem--cf3b0";
export var linksItemLarge = "Footer-module--linksItemLarge--05a5c";
export var logo = "Footer-module--logo--772b4";
export var social = "Footer-module--social--faf94";
export var text = "Footer-module--text--d4410";
export var title = "Footer-module--title--746dc";
export var wrapper = "Footer-module--wrapper--5f1e5";